











































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import InputControl from "@/components/Controls/InputControl.vue";
import TextareaControl from "@/components/Controls/TextareaControl.vue";
import ReportModel from "@/model/Report";

const UserStore = namespace("User");
const FormStore = namespace("Form");

@Component({
  name: "ReportSummary",
  components: {
    InputControl,
    TextareaControl
  }
})
export default class ReportSummary extends Vue {
  @Prop({ required: true })
  readonly value!: ReportModel;

  @FormStore.State
  formDisabled!: boolean;

  private report: ReportModel | null = this.value;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public isUser!: boolean;

  @Watch("value") setValue(newValue: ReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
